export default "__VITE_ASSET__6ea2a513__"